import { getFormattedTickValue } from './getFormattedTickValue'
import { getGraphTicks } from './getGraphTicks'

const MIN_WIDTH = 36
const EXTRA_PADDING = 6
const MAX_TICK_LABEL_LENGTH = 4

// Calculates a suitable Y-axis width based on the length of the formatted tick labels
export const getGraphYAxisWidth = (domain: number[], locale?: string): number => {
  const ticks = getGraphTicks(domain)
  const maxTickLabelLength = Math.max(...ticks.map((tick) => getFormattedTickValue(tick, locale).length))

  // Increase Y-axis width proportionally to label length
  const additionalNumber = maxTickLabelLength >= MAX_TICK_LABEL_LENGTH ? EXTRA_PADDING : 0

  return MIN_WIDTH + additionalNumber
}
